import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import { handleNotificationAlertCatch, handleNotificationAlertTrySelect } from 'common/method/handleNotificationAlert'


export const actionTypes = {
    selectMarkowitsCalculater: "selectMarkowitsCalculater [Action]",
    selectMarkowitsCalculaterLoading: "selectMarkowitsCalculaterLoading [Action]",
    selectMarkowitsCalculaterAsync: "selectMarkowitsCalculaterAsync [Action]",
};
const inistiaState = {
    data: {},
    loading: false,
    total:0
};

export const selectMarkowitsCalculaterReducer = (state = inistiaState, { type, payload }) => {
    switch (type) {
        case actionTypes.selectMarkowitsCalculater:
            return {
                ...state,
                data: payload,
                // total: payload?.total,
            };
        case actionTypes.selectMarkowitsCalculaterLoading:
            return {
                ...state,
                loading: payload,
            };
        default:
            return state;
    }
};

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.selectMarkowitsCalculaterLoading, payload: true })


    let config = {
        url: "select_request"
    };

    let data = {
        table: "portfolio",
        method_type: "calculate_markowitz_portfolio",
        data: payload?.data ? payload.data : {},
        "from": 0,
        "size": 6,
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
            return;
        }

        
        yield put({ type: actionTypes.selectMarkowitsCalculater, payload: res?.data?.response?.data})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.selectMarkowitsCalculaterLoading, payload: false })

    }
}

export function* selectMarkowitsCalculater() {
    yield takeLatest(actionTypes.selectMarkowitsCalculaterAsync, handleWorker);
}
